import React from 'react';
import PropTypes from 'prop-types';
import {SALE} from '../../../../../consts';

function ContactsHidden (props) {
  const updated = props.item.getUpdatedDate().fromNow();
  const dealType = props.item.getDealType();

  return (
    <td className='col-contacts'>
      <div>
        Объявление находится в архиве.
        <br />
        <br />
        Контакты продавца скрыты
      </div>
      <br />
      <div className='dates'>
        <div>{(dealType === SALE ? 'Продано ' : 'Сдано ') + updated}</div>
      </div>
    </td>
  );
}

ContactsHidden.propTypes = {
  item: PropTypes.object.isRequired
};
ContactsHidden.defaultProps = {};

export default ContactsHidden;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/Cells/GridCells/ContactsHidden.jsx